var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseFilterIcon = function SvgCloseFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.134 6.478 2.364 4 .134 1.522a.548.548 0 0 1-.002-.71.45.45 0 0 1 .147-.108.41.41 0 0 1 .345.002.45.45 0 0 1 .146.11L3 3.294 5.23.816a.45.45 0 0 1 .146-.11.411.411 0 0 1 .345-.002.45.45 0 0 1 .147.109.548.548 0 0 1-.002.71L3.636 4l2.23 2.478a.548.548 0 0 1 .002.71.45.45 0 0 1-.147.108.41.41 0 0 1-.346-.002.45.45 0 0 1-.146-.11l-2.23-2.478L.77 7.184a.428.428 0 0 1-.317.144.428.428 0 0 1-.316-.147.529.529 0 0 1-.132-.35.53.53 0 0 1 .13-.353Z",
    fill: "#868E96"
  })));
};
export default SvgCloseFilterIcon;